import createRootReducer from './reducers';
import {createStore} from 'redux';

const store = createStore(createRootReducer);

export default store;
